import {
  GeneralIcon,
  ReportsIcon,
  HostingIcon,
  ImageIcon,
  LogDrainIcon,
} from "gatsby-interface"
import { LayersIcon, PackageIcon } from "gatsby-ui/src/components/icons"
import { SiteSettingsSection, SiteSettingsSectionLabel } from "../constants"
import { getSiteDetailsTabBasePath } from "../../details/utils"
import { SiteDetailsTab } from "../../details/constants"
import getSideNavOptions from "../../../layout/utils/getSideNavOptions"
import { useFlags } from "@modules/featureFlags"
import { MachinePricingTier } from "@modules/graphql/types"

const siteSettings = [
  {
    id: SiteSettingsSection.General,
    Icon: GeneralIcon,
    subsections: [
      {
        id: SiteSettingsSection.SiteDetails,
      },
      {
        id: SiteSettingsSection.EnvVars,
      },
      {
        id: SiteSettingsSection.Webhook,
      },
      {
        id: SiteSettingsSection.NotificationDeploys,
      },
      {
        id: SiteSettingsSection.VisitorAccess,
      },
      {
        id: SiteSettingsSection.Danger,
      },
    ],
  },
  {
    id: SiteSettingsSection.Builds,
    Icon: PackageIcon,
    subsections: [
      {
        id: SiteSettingsSection.BuildTypes,
      },
      {
        id: SiteSettingsSection.BuildFeatures,
      },
    ],
  },
  {
    id: SiteSettingsSection.ContentHub,
    Icon: LayersIcon,
    subsections: [
      {
        id: SiteSettingsSection.DataSources,
      },
      {
        id: SiteSettingsSection.Webhook,
      },
    ],
  },
  {
    id: SiteSettingsSection.Hosting,
    Icon: HostingIcon,
    subsections: [
      {
        id: SiteSettingsSection.GatsbyHosting,
      },
      {
        id: SiteSettingsSection.Domains,
      },
      {
        id: SiteSettingsSection.HostingIntegrations,
      },
    ],
  },
  {
    id: SiteSettingsSection.ImageCDN,
    Icon: ImageIcon,
  },
  {
    id: SiteSettingsSection.Reports,
    Icon: ReportsIcon,
  },
  {
    id: SiteSettingsSection.LogDrains,
    Icon: LogDrainIcon,
    isNew: true,
  },
]

export function useSiteSettingsNavigation({
  organizationId,
  siteId,
  location,
  buildsEnabled,
  tier,
}) {
  const { flags } = useFlags()

  return getSideNavOptions({
    sections: siteSettings,
    sectionLabels: SiteSettingsSectionLabel,
    getLink: sectionId =>
      `${getSiteDetailsTabBasePath(
        SiteDetailsTab.Settings,
        siteId,
        organizationId
      )}/${sectionId}`,
    location,
    filterWith: (sectionId, _options = {}) => {
      if (sectionId === SiteSettingsSection.Reports) {
        return buildsEnabled
      }

      if (sectionId === SiteSettingsSection.HostingIntegrations) {
        return buildsEnabled
      }

      if (sectionId === SiteSettingsSection.Hosting) {
        return buildsEnabled
      }

      if (sectionId === SiteSettingsSection.LogDrains) {
        return tier === MachinePricingTier.Enterprise
      }

      return true
    },
  })
}
